<template>
  <div>
    <ul class="ak-color-picker__colors">
      <li
        v-for="item in colorsDefault"
        :key="item"
        class="ak-color-picker__colors-item"
        @click="selectColor(item)"
      >
        <div :style="{ background: `url(${imgAlphaBase64})` }" class="alpha" />
        <div :style="{ background: item }" class="ak-color-picker__color" />
      </li>
    </ul>
    <ul
      v-if="colorsHistory.length"
      class="ak-color-picker__colors ak-color-picker__colors--history"
    >
      <li
        v-for="item in colorsHistory"
        :key="item"
        class="ak-color-picker__colors-item"
        @click="selectColor(item)"
      >
        <div
          :style="{ background: `url(${imgAlphaBase64})` }"
          class="ak-color-picker__alpha"
        />
        <div :style="{ background: item }" class="ak-color-picker__color" />
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent, ref, onBeforeUnmount, onMounted } from 'vue'
import colorPickerMixin from '../../mixins/colorPickerMixin'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-color-picker-colors />
   */
  name: 'AkColorPickerColors',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    color: {
      type: String,
      default: '#000000',
    },

    colorsDefault: {
      type: Array,
      default: () => [],
    },

    colorsHistoryKey: {
      type: String,
      default: '',
    },
  },

  emits: ['selectColor'],

  setup(props, { emit }) {
    const mixin = colorPickerMixin()
    const imgAlphaBase64 = ref('')
    const colorsHistory = ref(
      JSON.parse(localStorage.getItem(props.colorsHistoryKey)) || []
    )

    const selectColor = (color) => {
      emit('selectColor', color)
    }

    const setColorsHistory = (color) => {
      if (!color) return

      const colors = colorsHistory.value
      const index = colors.indexOf(color)

      if (index >= 0) {
        colors.splice(index, 1)
      }

      if (colors.length >= 8) {
        colors.length = 7
      }

      colors.unshift(color)
      colorsHistory.value = colors
      localStorage.setItem(props.colorsHistoryKey, JSON.stringify(colors))
    }

    onMounted(() => {
      imgAlphaBase64.value = mixin.createAlphaSquare(4).toDataURL()
    })

    onBeforeUnmount(() => {
      setColorsHistory(props.color)
    })

    return {
      imgAlphaBase64,
      colorsHistory,
      selectColor,
      setColorsHistory,
      ...mixin,
    }
  },
})
</script>

<style lang="scss" rel="stylesheet/scss">
.ak-color-picker {
  &__colors {
    padding: 0;
    margin: 0;

    &--history {
      margin-top: 10px;
      border-top: 1px solid rgba(0, 0, 0, 0.15);
    }

    &-item {
      position: relative;
      width: 16px;
      height: 16px;
      margin: 10px 0 0 10px;
      border-radius: 3px;
      box-sizing: border-box;
      vertical-align: top;
      display: inline-block;
      transition: all 0.1s;
      cursor: pointer;

      &:nth-child(8n + 1) {
        margin-left: 0;
      }

      &:hover {
        transform: scale(1.4);
      }
    }
  }
  &__alpha {
    height: 100%;
    border-radius: 4px;
  }

  &__color {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 3px;
  }
}
</style>
